import React from 'react';

import { Home } from './Home';
import { About } from './About';
import { Download } from './Download';
import { Footer } from './Footer';

export const Root = () => (
  <div>
    <Home />
    <About />
    <Download />
    <Footer />
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Root.jsx